import { ReactNode } from 'react';
import { Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { color } from '@/colors';
import { FlexCol } from '@/UI/styles';
import { SettingsPageSections } from '@/enums/settings-page-sections.enum';

interface SettingsDrawerProps {
  settingsList: {
    menuLabel: string;
    icon: ReactNode;
    section: SettingsPageSections;
    disable?: boolean;
    badgeLabel?: string;
  }[];
  selectedSection: SettingsPageSections | undefined;
  setSelectedSection: (section: SettingsPageSections) => void;
}

function SettingsDrawer({ settingsList, selectedSection, setSelectedSection }: SettingsDrawerProps) {
  return (
    <FlexCol sx={{ justifyContent: 'space-between', width: '240px' }}>
      <Box data-testid="settings-drawer-upper-container">
        <List sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, p: 0 }}>
          {settingsList.map((item) => (
            <ListItem
              key={item.menuLabel}
              disablePadding
              sx={{
                background: item.section === selectedSection ? color.Black92 : '',
                '& .MuiListItemIcon-root': { minWidth: '30px' },
              }}
            >
              <ListItemButton onClick={() => setSelectedSection(item.section)} disabled={item.disable}>
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText
                  primary={
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                      <span>{item.menuLabel}</span>
                      {item.badgeLabel && (
                        <Box
                          component="span"
                          sx={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            px: '6px',
                            height: '16px',
                            borderRadius: '2px',
                            backgroundColor: color.Yellow16_T,
                            color: color.Yellow100,
                            fontSize: '10px',
                            fontWeight: 600,
                            lineHeight: '12px',
                          }}
                        >
                          {item.badgeLabel}
                        </Box>
                      )}
                    </Box>
                  }
                  sx={{
                    '& .MuiListItemText-primary': {
                      fontWeight: item.section === selectedSection ? 500 : 400,
                    },
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
    </FlexCol>
  );
}

export default SettingsDrawer;
